<div class="modal-content-with-padding">
  <nts-labelled-text-box [propertyViewModel]="viewModel.title" [fullColumn]="true">
  </nts-labelled-text-box>
</div>